
import React from 'react';
import { useNavigation } from '../contexts/NavigationProvider';
import { useLanguage } from '../contexts/LanguageProvider';

const Footer: React.FC = () => {
    const { handleNavigation } = useNavigation();
    const { t } = useLanguage();

    return (
        <footer className="bg-brand-surface border-t border-gray-800 mt-20 pt-12 pb-32 md:pb-8 px-4 font-urbanist">
            <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
                <div className="space-y-4">
                    <div>
                        <img src="/logo.png" alt="beYourAMP" className="h-10 w-auto" />
                    </div>
                    <p className="text-gray-400 text-sm max-w-md leading-relaxed font-medium">
                        The Professional Network for the Entertainment Industry. Connecting talent, business, and production in one unified stage.
                    </p>
                    <div className="text-[10px] text-brand-muted font-bold uppercase tracking-widest space-y-1">
                        <p>beYourAMP s.r.l.</p>
                        <p>VAT / Fiscal Code: 18397091002</p>
                        <p>PEC: beyouramp@pec.it</p>
                        <p>Share Capital: € 7.000,00</p>
                    </div>
                </div>

                <div className="flex flex-col md:items-end justify-between h-full">
                    <div className="flex flex-wrap gap-x-6 gap-y-2 mb-6">
                        <button onClick={() => handleNavigation('terms')} className="text-xs font-black text-brand-muted hover:text-white uppercase tracking-widest transition-colors">
                            {t('TERMS_NAV')}
                        </button>
                        <button onClick={() => handleNavigation('privacy')} className="text-xs font-black text-brand-muted hover:text-white uppercase tracking-widest transition-colors">
                            {t('PRIVACY_NAV')}
                        </button>
                        <button onClick={() => handleNavigation('cookies')} className="text-xs font-black text-brand-muted hover:text-white uppercase tracking-widest transition-colors">
                            {t('COOKIE_NAV')}
                        </button>
                    </div>
                    <p className="text-[10px] text-brand-muted font-bold uppercase tracking-[0.3em]">
                        &copy; {new Date().getFullYear()} beYourAMP. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
